var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractsMenuIconsHoverV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4931 1.58098C10.382 1.46984 10.2312 1.40741 10.0741 1.40741H4.8C3.70362 1.40741 2.81482 2.29621 2.81482 3.39259V13.1111C2.81482 13.4384 3.08013 13.7037 3.40741 13.7037H10.9037C12.0001 13.7037 12.8889 12.8149 12.8889 11.7185V4.22222C12.8889 4.06506 12.8265 3.91433 12.7153 3.8032L10.4931 1.58098ZM4.8 2.59259H9.82862L11.7037 4.46768V11.7185C11.7037 12.1603 11.3455 12.5185 10.9037 12.5185H4V3.39259C4 2.95077 4.35818 2.59259 4.8 2.59259Z",
    fill: "#3537E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92593 2C8.92593 1.67272 9.19125 1.40741 9.51853 1.40741C9.84581 1.40741 10.1111 1.67272 10.1111 2V3.66396C10.1111 3.95271 10.3433 4.18519 10.6323 4.18519H12.2963C12.6236 4.18519 12.8889 4.4505 12.8889 4.77778C12.8889 5.10506 12.6236 5.37037 12.2963 5.37037H10.6323C9.6884 5.37037 8.92593 4.60693 8.92593 3.66396V2Z",
    fill: "#3537E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62963 9.81483C5.30235 9.81483 5.03703 9.54951 5.03703 9.22223C5.03703 8.89495 5.30235 8.62964 5.62963 8.62964H10.0741C10.4014 8.62964 10.6667 8.89495 10.6667 9.22223C10.6667 9.54951 10.4014 9.81483 10.0741 9.81483H5.62963Z",
    fill: "#3537E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2963 7.5926C6.96902 7.5926 6.7037 7.32728 6.7037 7C6.7037 6.67272 6.96902 6.40741 7.2963 6.40741H10.0741C10.4014 6.40741 10.6667 6.67272 10.6667 7C10.6667 7.32728 10.4014 7.5926 10.0741 7.5926H7.2963Z",
    fill: "#3537E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsMenuIconsHoverV4);
export default __webpack_public_path__ + "static/media/contracts-menu-icons-hover-v4.6f2997117492763929502d44466686c3.svg";
export { ForwardRef as ReactComponent };